// Components==============
import Modal from 'components/UI/Modal/Modal';
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { interactiveScale } from 'utilities/FramerAnimations';
import { GlobalRootDreamContext } from 'utilities/GlobalContext/GlobalRootDream';
import './AddDreamModal.module.scss';
// =========================

export default function AddDreamModal() {
  const publicDreams = useRedux((state) =>
    state.dream?.entities.allIds
      .map((id) => state.dream?.entities.byId[id])
      .filter((dream) => !!dream?.is_public)
  );

  const { closeModal } = useRootModal();

  const { setRootDreamModal } = useContext(GlobalRootDreamContext);
  const translate = useTranslate();

  return (
    <Modal size="medium">
      <div styleName="content">
        <div>
          <h2>{translate('dream.pick-a-template')}</h2>
          <motion.button
            {...interactiveScale}
            type="button"
            onClick={() => {
              closeModal();
              setRootDreamModal({ origin: 'add-dream' });
            }}
          >
            <img src="/images/empty-template.svg" alt="empty-template" />
            <p styleName="description">
              {translate('dream.terms.empty-template')}
            </p>
          </motion.button>
        </div>
        <div>
          <h3>{translate('general.terms.examples')}</h3>
          <div styleName="dreams">
            {publicDreams?.map(
              (dream) =>
                dream && (
                  <ReflectionIcon
                    key={dream?.id}
                    name={dream?.name}
                    image={dream?.image}
                    onClick={() => {
                      closeModal();
                      setRootDreamModal({ origin: 'template', dream });
                    }}
                  />
                )
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
